import {FAILED_AUTH_INDEX} from '@web-catalog/const/numbers';

import {useActiveCategory} from '@web-catalog/hooks/useActiveCategory';

import {useAuthorizedProfile} from '@web-catalog/store/auth';

import {logTmrEvent} from './logEvent';

// ToDo: зависимости передавать параметрами в функцию. Перенести в baseLog analytics.js
export const useScrollAnalytics = () => {
  const activeCategory = useActiveCategory();
  const userInfo = useAuthorizedProfile();
  const appCategoryName = activeCategory?.category || '';

  const logScrollDownScroll = (scrollDepth: number) => {
    logTmrEvent({
      logEvent: 'scrollDown.scroll',
      params: {
        app_category_name: appCategoryName,
        scrollDepth,
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });
  };

  return {
    logScrollDownScroll,
  };
};
